export default __webpack_public_path__ + "static/media/duck-cart.5b7cb32c.jpg";